import { BmHttp as Http } from "../utils/Global";

export const Billing = async (payload) => {
  try {
    const { data } = await Http().post(`billing`, payload);
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const ProcedimientosNuevosBilling = async (payload) => {
  try {
    const { data } = await Http().post(`billing/procedures/news`, payload);
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const ProcedimientosDeleteBilling = async (id) => {
  try {
    const { data } = await Http().put(`billing/procedures/${id}`);
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const UpdateInvoice = async (documento, payload) => {
  try {
    const { data } = await Http().put(`billing/${documento}`, payload);
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetInvoiceAllResp = async ({ page = 1, limit = 10, filters }) => {
  try {
    const { documento, fecha_inicial, fecha_final, tipo, paciente, contifico } =
      filters;

    const { data } = await Http().get(`billing/`, {
      params: {
        page,
        limit,
        documento,
        fecha_inicial,
        fecha_final,
        tipo,
        paciente,
        contifico,
      },
    });
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const GetInvoiceAll = async ({ page = 1, limit = 10, filters }) => {
  try {
    const { documento, fecha_inicial, fecha_final, tipo, paciente, contifico } =
      filters;

    const { data } = await Http().get(`billing/`, {
      params: {
        page,
        limit,
        documento,
        fecha_inicial,
        fecha_final,
        tipo,
        paciente,
        contifico,
      },
    });

    return data;
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || "Error desconocido",
      data: [],
      pagination: {
        total: 0,
        page,
        limit,
        pages: 1,
      },
    };
  }
};

export const DeleteInvoice = async (documento, payload) => {
  try {
    const { data } = await Http().put(`billing/delete/${documento}`, payload);
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetInvoiceComPDF = async (num_documento) => {
  try {
    const data = await Http().get(`comprobante/${num_documento}`, {
      responseType: "blob",
    });
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetMatrizAtenciones = async (page, limit, filters) => {
  try {
    const fecha_inicial = filters?.fecha_inicial;
    const fecha_final = filters?.fecha_final;

    const { data } = await Http().get(`/reporte/matrizatenciones`, {
      params: { page, limit, fecha_inicial, fecha_final },
    });
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetInvoiceCajaExcel = async (filters) => {
  try {
    const fecha_inicial = filters?.fecha_inicial;
    const fecha_final = filters?.fecha_final;

    const response = await Http().get(`reporte/matrizatenciones/excel`, {
      params: { fecha_inicial, fecha_final },
      responseType: "blob",
    });

    return response;
  } catch (error) {
    console.error("Error descargando Excel:", error);
    return (
      error?.response?.data || {
        success: false,
        message: "Error al descargar el reporte.",
      }
    );
  }
};

export const ResendInvoiceContifico = async (num_documento) => {
  try {
    // Permite pasar string o un objeto { num_documento }
    const payload =
      typeof num_documento === "string"
        ? { num_documento }
        : { num_documento: num_documento?.num_documento };

    if (!payload.num_documento) {
      return { success: false, message: "num_documento es requerido" };
    }

    const { data } = await Http().post(`billing/contifico`, payload);
    // El backend puede responder 201 Created; axios igual te da data.
    return data;
  } catch (error) {
    return (
      error?.response?.data ?? {
        success: false,
        message: error?.message || "Error desconocido",
      }
    );
  }
};
// 2) Envía el payload a Contífico
export const SendPayloadContifico = async (payload) => {
  try {
    const { data } = await Http().post(`billing/contifico/send`, payload);
    return data; // { success, data: <resp contifico>, message }
  } catch (error) {
    return (
      error?.response?.data ?? {
        success: false,
        message: error?.message || "Error desconocido",
      }
    );
  }
};
